import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SnackBarInfo } from '../models/snackbar.model';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private message = inject(MessageService);

  constructor() { }

  openSnackbar (snackBarInfo: SnackBarInfo) {
    this.message.add({
      summary: snackBarInfo.title,
      detail: snackBarInfo.body,
      severity: snackBarInfo.type,
      styleClass: snackBarInfo.type,
      life: snackBarInfo.timespan && !isNaN(snackBarInfo.timespan) ? snackBarInfo.timespan : 3000,
      key: 'general',
      closable: false,
    })
  }

  clearSnackbar () {
    this.message.clear('general')
  }
}
